module.exports = __webpack_public_path__ + "static/media/25115029_1545557705493865_1985953166_n_edited_edited.cc28e6d6.jpg";